import React from 'react';
import { useModal } from '@/context/modalContext';
import { useOneCmsWaitlistContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';
import {
  Button,
  Link,
  AlertDialog,
  AlertDialogBody,
  AlertDialogHeader,
} from '@americanexpress/dls-react';
import clsx from 'clsx';
import { useUserWaitListDetails } from '@/hooks/waitListHooks/waitListHelperHooks';
import { useLoungeById } from '@/hooks/loungesHooks/loungesHelperHooks';
import { useRouteParams } from '@/context/routeParamsContext';
import { IconChair } from '@/components/icons';
import { LoungeTypes } from '@/constants/index';
import { useAnalyticsContext } from '@/context/analyticsContext';
import { saveScrollBeforeExternalNavigation } from '@/helpers/utils';
import { WAITLIST_SCROLL_POSITION_KEY } from '@/constants/waitlistLounges';
import styles from './BeforeYouGo.module.scss';

const BeforeYouGoConfirmationModal = () => {
  const { loungeId } = useRouteParams();
  const { url } = useUserWaitListDetails(loungeId);
  const { experience_type: experienceType } = useLoungeById(loungeId);
  const { closeModal } = useModal();
  const {
    modal: { header, body, sidecarBody, confirmButtonLabel, cancelButtonLabel },
  } = useOneCmsWaitlistContent();
  const { customTrack } = useAnalyticsContext();

  const clickHandler = (event, buttonLabel) => {
    customTrack({
      event,
      detail: `${buttonLabel}`,
      element: `WaitList Confirmation Modal`,
    });
    closeModal();
  };

  const handleContinueClick = (event) => {
    clickHandler(event, 'continue to waitlist');
    saveScrollBeforeExternalNavigation({
      storageKey: WAITLIST_SCROLL_POSITION_KEY,
    });
  };

  return (
    <AlertDialog className={styles.alertDialogBody} onClose={closeModal}>
      <AlertDialogHeader
        className="tw-heading-sm-bold tw-items-center tw-p-6 tw-pb-4"
        icon={<IconChair />}
      >
        {header}
      </AlertDialogHeader>
      <AlertDialogBody
        actionSlot={
          <>
            <Link
              className={clsx(
                'btn primary btn-primary flex-justify-center dls-white tw-w-full tw-max-w-300',
                styles.waitListButton
              )}
              href={url}
              isInline
              onClick={handleContinueClick}
              reactlytics={{ disable: true }}
              target="_blank"
            >
              {confirmButtonLabel}
            </Link>
            <Button
              variant="secondary"
              onClick={(e) => clickHandler(e, 'exit waitlist pop up')}
              reactlytics={{
                disable: true,
              }}
            >
              {cancelButtonLabel}
            </Button>
          </>
        }
      >
        {experienceType === LoungeTypes.SIDECAR ? sidecarBody : body}
      </AlertDialogBody>
    </AlertDialog>
  );
};

export default BeforeYouGoConfirmationModal;
